import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';

const EssentialsTemplate = ({ link, name, description, initialRequestStatus }) => {

    const [requestStatus, setRequestStatus] = useState(initialRequestStatus);
    const [isSignedIn, setIsSignedIn] = useState(false);
    const [showModal, setShowModal] = useState(false);

    async function currentSession() {
        try {
            const accessToken = sessionStorage.getItem('accessToken');
            const idToken = sessionStorage.getItem('idToken');
            if (idToken != null && accessToken != null) {
                setIsSignedIn(true);
            } else {
                setIsSignedIn(false);
            }
        } catch (err) {
            setIsSignedIn(false);
        }
    }

    useEffect(() => {
        currentSession();
    }, []);

    const handleClose = () => setShowModal(false);

    const handleButtonClick = () => {

        //Showing a modal with screenshots in the meantime
        setShowModal(true);

        // Uncomment the following code to enable the request button once redirect is implemented.
        // if (isSignedIn) {
        //     setRequestStatus('Requested');
        // } else {
        //     alert('Please sign in to request this product');
        //     const loginUrl = 'https://accounts.charmtracker.com/oauth/v2/auth?client_id=1000.RB6DWOYZJ54A25SZPTB5D3P8DQP0SQ&redirect_uri=https://charmhealthhub.com/authenticating&scope=openid+email+charmhealth.user.addons.READ&response_type=token';
        //     window.location.href = loginUrl;
        // }
    };

    return (
        <div className="w-full h-[160px] flex flex-col p-4 bg-productBackground shadow-xl">
            <div className="w-full flex flex-row gap-4 items-center h-40 justify-center">
                {/* <div className="w-24 h-24 flex-shrink-0">
                    {link ? (
                        <img src={link} alt="logo" className="h-full w-full object-contain rounded-2xl" />
                    ) : (
                        <div className="h-full w-full bg-neutral" />
                    )}
                </div> */}
                <div className="flex flex-col">
                    <div className="text-left text-xl md:text-2xl xl:text-3xl font-bold font-proxima-nova">{name}</div>
                    <div
                        className="text-base text-lg md:text-xl 2xl:text-2xl overflow-y-auto"
                        style={{ maxHeight: '80px' }}  // Set your desired max height
                    >
                        {description}
                    </div>
                </div>

            </div>

            <div className="mt-4 flex items-center justify-center">
                <div className="flex flex-row items-center">
                    {requestStatus === 'Requested' && (
                        <div className={`h-3 w-3 rounded-full bg-productRequested`}></div>
                    )}
                    {requestStatus === 'Integrated' && (
                        <div className={`h-3 w-3 rounded-full bg-focusOutline`}></div>
                    )}

                    <div className="ml-2 flex items-center">
                        {requestStatus === 'Integrate' ? (
                            <button
                                onClick={handleButtonClick}
                                className="px-4 py-1 bg-productRequest rounded-full text-productRequestText text-md w-32"
                            >
                                Integrate
                            </button>
                        ) : (
                            <h3 className="mt-2 italic text-sm"> {requestStatus}</h3>

                        )}
                    </div>
                </div>
            </div>


            {/* Modal */}
            {/* Modal */}
            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Integration Steps</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p className="mb-4">
                            We are working hard to bring direct integrations very soon. Until then, please follow these simple steps to get this product integrated into your system.
                        </p>
                        <div className="mb-3">
                            <p><strong>Step 1:</strong> Please visit <a href="https://ehr2.charmtracker.com/ehr/main.do" target="_blank" rel="noopener noreferrer">https://ehr2.charmtracker.com/ehr/main.do</a>, log in, and select your facility.</p>
                        </div>
                        <div className="mb-3 d-flex align-items-center">
                            <p><strong>Step 2:</strong> Click on the settings icon <span className="ml-2 mr-2">&#9881;</span> in the top right corner, and proceed to the settings page.</p>
                        </div>
                        <div className="mb-3">
                            <p><strong>Step 3:</strong> Search for <strong>{name}</strong> and click on it to integrate.</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default EssentialsTemplate;